import { AxiosError } from "axios";
import { ValidationError } from "myzod";
import { Dispatch, SetStateAction } from "react";
import {
  fetchPlan,
  getPlanDateRangeOrNull
} from "../../../features/Booking-Form/functions/floor.functions";
import { findInitialFloorIndex } from "../../../features/Booking-Form/functions/form.functions";
import { hasActiveBookingFilters } from "../../../features/Booking-Form/functions/booking-filter-state.functions";
import { NotSerializedBookingInputs } from "../../../features/Booking-Form/typings/booking-inputs";
import { FloorAvailability } from "../../../features/FloorManager/typings/floor-inventory.entity";
import { IFloorPayload } from "../../FacilityManager/Domain/Types/FloorPlan/FloorPayload.type";

export const handleFloorFetch = (
  inputs: NotSerializedBookingInputs,
  floors: {
    inventory: FloorAvailability[];
    isLoading: boolean;
    currentFloorIndex?: number;
    error?: AxiosError | ValidationError;
  },
  setFloorPlan: Dispatch<SetStateAction<IFloorPayload | undefined>>
) => {
  if (!inputs.isMobileWorking && !inputs.automatedSeating && !inputs.activityBasedBooking) {
    const { inventory, currentFloorIndex } = floors;
    if (!inventory.length) return;

    const resolvedIndex =
      currentFloorIndex ??
      findInitialFloorIndex(inventory, hasActiveBookingFilters(inputs.bookingFilters));

    const floor = inventory[resolvedIndex];
    if (!floor) return;
    if (
      !getPlanDateRangeOrNull(
        inputs.bookingFrom,
        inputs.bookingStart,
        inputs.bookingTo,
        inputs.bookingEnd
      )
    ) {
      return;
    }
    fetchPlan(
      floor.id,
      inputs.bookingFrom,
      inputs.bookingStart,
      inputs.bookingEnd,
      inputs.bookingTo
    ).then(res => {
      if (res) {
        setFloorPlan(res);
      }
    });
  }
};

export const handleResourceFloorFetch = (
  inputs: NotSerializedBookingInputs,
  floorInventoryId: number,
  setFloorPlan: Dispatch<SetStateAction<IFloorPayload | undefined>>
) => {
  if (
    !getPlanDateRangeOrNull(
      inputs.bookingFrom,
      inputs.bookingStart,
      inputs.bookingTo,
      inputs.bookingEnd
    )
  ) {
    return;
  }
  fetchPlan(
    floorInventoryId,
    inputs.bookingFrom,
    inputs.bookingStart,
    inputs.bookingEnd,
    inputs.bookingTo
  ).then(res => {
    if (res) {
      setFloorPlan(res);
    }
  });
};
